import 'babel-polyfill';
import GuID from '../helpers/guid';
import domtoimage from "dom-to-image";

class Buy {

    constructor() {

        this.buyElement = '.personalizator__product-details-buy button';
        this.form = '#personalizator__form';

        this.modal = '#loading-modal';
        this.modalBought = '#cart-modal';
        this.elements = '.personalizator__product-image-content';

        this.bindBuy();
        this.bindDesc();

    }

    bindBuy() {

        $(document).ready(() => {

            $(this.buyElement).on('click', (event) => {

                this.showModal();

                setTimeout(() => {

                    $(this.elements).each(async (index, element) => {

                        $(element).addClass('active');

                        if ($(element).data('type') !== 'front') {
                            $(element).css('opacity', '0.01');
                        }

                        this.toggleElementAssets(element, false);

                        let elementHtml = $(element).find('.personalizator__product-image-content-icon')[0];

                        return await this.createPreview(elementHtml, element);

                    });

                    setTimeout(() => {

                        let elements = [];
                        let previews = [];

                        $('.personalizator__element').each((index, element) => {
                            let el = JSON.parse($(element).data('element'));
                            let data;

                            if (el.type !== 'img') {
                                data = el.value
                            } else {
                                data = el.image.split('/').reverse()[0];
                            }

                            elements.push({
                                type: el.tabType,
                                el: el,
                                data
                            });

                        });

                        $('.previewInput').each((index, element) => {

                            previews.push($(element).val());

                        });


                        setTimeout(() => {

                            const data = {
                                elements: elements,
                                qty: $('#personalizator__qty').val(),
                                variant: $(`#variant_${$('.variant-sizes').val()}`).data('id'),
                                size: $(`#variant_${$('.variant-sizes').val()}`).text(),
                                guid: $('#personalizator__guid').val(),
                                productId: $('#product_id').val(),
                                preview: previews,
                                description: $('#description textarea').val(),
                                attachments: $('#personalizator__attachment').data('attachments')
                            };

                            $.post('/personalizacja/addToCart', data)
                                .done((response) => {

                                    const pvid = $(`#variant_${$('.variant-sizes').val()}`).data('id');
                                    const size = $(`#variant_${$('.variant-sizes').val()}`).text();
                                    const qty = $('#personalizator__qty').val();

                                    let bskCookie = getCookie(`bsk[${pvid}]`);

                                    if (!bskCookie) {
                                        bskCookie = 0;
                                    }

                                    setCookie('qnty[' + pvid + ']', qty);
                                    setCookie(`bsk[${pvid}]`, parseInt(qty) + parseInt(bskCookie));
                                    setCookie('size[' + pvid + ']', size);

                                    this.refreshCartCount();

                                    this.hideModal();

                                    GuID.generateGuID();
                                })
                                .fail(err => console.error(err));

                        });

                    }, 30000);

                });

                return false;


            });

        });

    }

    async createPreview(elementHtml, element) {

        if (elementHtml) {
            const el = await html2canvas(elementHtml)
                .then(dataUrl => {
                    $(element).find('.previewInput').val(dataUrl.toDataURL("image/png"));
                    this.toggleElementAssets(element, true);
                    $(`.personalizator__modal-content-item-${$(element).data('type')}`).attr('src', dataUrl.toDataURL("image/png")).trigger('change');

                    $('.personalizator__navs-item').removeClass('active');
                    $('[data-tab=".personalizator__front"]').addClass('active');
                    $('[data-tab="#personalizator__insert-front-text"]').addClass('active');
                    $('#personalizator__insert-front-text').addClass('active');

                    if ($(element).data('type') !== 'front') {
                        $(element).removeClass('active').css('opacity', 1);
                    }
                });

            return el;
        }

    }

    bindDesc() {
        $(document).ready(() => {
            $('#desc').change(() => {
                $('#description').slideToggle();
            });
        })
    }

    toggleElementAssets(element, show) {

        $(element).find('.remove').toggle();
        $(element).find('.ui-resizable-handle').toggle();
        $(element).find('.ui-rotatable-handle').toggle();

        if (show) {

            $(element).find('.personalizator__fly').css('border-color', '#000');

        } else {

            $(element).find('.personalizator__fly').css('border-color', 'transparent');

        }

    }

    showModal() {
        $(this.modal).addClass('dialog--show');
    }

    hideModal() {
        $(this.modal).removeClass('dialog--show');

        this.showBoutghtModal();
    }

    showBoutghtModal() {
        $('.layer.infoWindow').fadeIn(100);
        licz_infoWindow = 3;
        if (infoWindowTimeout) {
            clearTimeout(infoWindowTimeout);
        }
        zamknij_infoWindow();
    }

    refreshCartCount() {
        ajax_last_request = $.get('/a_basket/', function (data) {
            $('#basket__icon').html(data);
        });
    }

}

export const buy = new Buy();
